import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Image from '../../shared/styledComponents/Image';

export default InjectedStyledComponent(Image, 'header', ['logo']);
